module.exports = __webpack_public_path__ + "static/hyperv_54.e54fd807.png";